import { OFFER_ACCEPTANCE_STATUSES } from 'cpool-constants';
import { z } from 'zod';

import { schemaEuropaceAntrag } from '../Angebote';

export const schemaEuropaceAcceptedOffer = z.object({
    antrag: schemaEuropaceAntrag.optional(),
    status: z.nativeEnum(OFFER_ACCEPTANCE_STATUSES),
});

export type SchemaEuropaceAcceptedOffer = z.infer<typeof schemaEuropaceAcceptedOffer>;
